import { render, staticRenderFns } from "./DomainVerification.vue?vue&type=template&id=3cebe0b6&"
import script from "./DomainVerification.vue?vue&type=script&lang=js&"
export * from "./DomainVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports